module.exports = __webpack_public_path__ + "media/react/b2b/app/pages/student/student_report/math_no_calc-90c1da0c0d9e979bb74c18f9cc99e76f.svg";